import { API_URL } from "@/constants/constants";
import axios from "axios";

export default class GastosProvider {
  static async deleteGasto(id) {
    const respuesta = await axios.delete(`${API_URL}/api/gasto/${id}`);
    return respuesta.data.message;
  }

  static async getGastos() {
    const respuesta = await axios.get(API_URL + `/api/gastos`);
    return respuesta.data.data.gastos;
  }

  static async getTipos() {
    const respuesta = await axios.get(API_URL + "/api/gasto/tipos");
    return respuesta.data.data.tipos;
  }

  static async getSubTipos(idTipo) {
    const respuesta = await axios.get(
      API_URL + `/api/gasto/subtipos/?idTipo=${idTipo}`
    );
    return respuesta.data.data.subtipos;
  }

  static async newGasto(gasto) {
    const respuesta = await axios.post(API_URL + "/api/gasto", gasto);
    return respuesta.data.id;
  }
}
